// ── Column definitions ─────────────────────────────────────────────────────────
// Title + dataIndex only — SbTable generates each column's searchable
// distinct-value filter from the rows it is given (uiCore/SbTable/columnFilters).

const COLUMN_DEFS = [
  { title: "Employee Name", dataIndex: "employee_name" },
  { title: "Requisition No.", dataIndex: "requisition_number" },
  { title: "Job Code",      dataIndex: "job_code"      },
  { title: "Role Name",     dataIndex: "role_name"     },
  { title: "Business",      dataIndex: "business_unit" },
  { title: "Function",      dataIndex: "function"      },
  { title: "Sub-Function",  dataIndex: "sub_function"  },
  { title: "Job Level",     dataIndex: "job_level"     },
  { title: "Location",      dataIndex: "location"      },
  { title: "Manager Name",  dataIndex: "manager_name"  },
];

const COLUMNS = COLUMN_DEFS.map(({ title, dataIndex }) => ({
  title,
  dataIndex,
  render: (val) => val || "--",
}));

// ── Hook ───────────────────────────────────────────────────────────────────────
// Columns are static; kept as a hook so the call site stays unchanged.

const useSkillsBridgerColumns = () => COLUMNS;

export default useSkillsBridgerColumns;
